@import '../../../theme.scss';

// See https://www.sliderrevolution.com/resources/styling-radio-buttons/
verdocs-field-radio {
  font-family: $verdocs-primary-font;
  width: 14px;
  height: 14px;
  display: block;
  font-size: 11px;
  position: relative;
  scroll-margin: 20px 0;
  background-color: transparent;
  transform-origin: bottom left;
  border-radius: 100%;

  svg {
    margin-top: 4px;
  }

  &.disabled.done {
    opacity: 1;
  }

  // To avoid conflicting with the use of a label for the checkbox itself
  div.label {
    top: -14px;
    left: -1px;
    height: 14px;
    color: white;
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #4a4a99;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  div.group {
    top: 14px;
    left: -1px;
    height: 14px;
    color: white;
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #bb0589;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  input {
    // This is needed to bring down the cursor from the parent element, which is where interactjs applies it
    cursor: inherit;
  }

  &.disabled input {
    opacity: 0.5;
  }

  &.done input[type='radio'] {
    margin: 0;
    padding: 0;
    width: 10px;
    height: 10px;
  }

  &:not(.done) input[type='radio'] {
    position: absolute;
    opacity: 0;

    + label {
      &:before {
        content: '';
        //background: $verdocs-grey-3;
        border-radius: 100%;
        border: 1px solid rgba(0, 0, 0, 0.6);
        display: inline-block;
        width: 12px;
        height: 12px;
        position: absolute;
        // This looks off in Storybook but correct in apps.
        left: 1px;
        top: 1px;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }

    &:checked {
      + label {
        &:before {
          background-color: $verdocs-green;
          box-shadow: inset 0 0 0 2px $verdocs-grey-3;
        }
      }
    }

    &:focus {
      + label {
        &:before {
          outline: none;
          border-color: $verdocs-green;
        }
      }
    }

    &:disabled {
      + label {
        &:before {
          box-shadow: inset 0 0 0 4px $verdocs-grey-3;
          border-color: #f3f3fc;
          background: #f3f3fc;
        }
      }
    }

    + label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }

  &.required {
    border: 1px solid var(--verdocs-required-field-border);
  }

  &.hide {
    display: none;
  }

  verdocs-button-panel {
    margin-left: -20px;
    margin-top: -7px;
    transform: scale(0.7);
  }

  .settings-icon {
    position: absolute;
    top: -6px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}
